import { ApiResponse } from './../models/ApiResponse';
import { DeceasedProfile } from './../models/DeceasedProfile';
import { QueueTicket } from './../models/QueueTicket';
import { SystemConfig } from './../models/SystemConfig';
import { SystemDataService } from './../service/data/system-data.service';
import { ObsDataService } from './../service/data/obs-data.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Account } from './../models/account';
import { DATA_OUTDATED, DATA_OUTDATED_ALERT_MESSAGE, OBS_IS_UNDER_MAINTENANCE, IN_OPERATION_MODE, IN_MAINTENANCE_MODE, BOOKING_MAX_ADVANCE_DAY, BOOKING_CANCEL_ADVANCE_DAY, ACCOUNT_ID_DROPDOWN_OPTIONS } from './../app.constant';
import { Alert } from './../models/Alert';
import { AccountDataService } from './../service/data/account-data.service';
import { BasicAuthenticationService } from './../auth/basic-authentication.service';
import { BookingDataService } from './../service/data/booking-data.service';
import { Booking } from './../models/booking';
import { Component, OnInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { stringify } from '@angular/compiler/src/util';

declare var $: any;

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  readonly DASHBOARD_ALERT_TOP_POSITION: string = "DASHBOARD_ALERT_TOP_POSITION";

  readonly ACCOUNT_BANNED_MESSAGE_SHOWN_SESSION_STORAGE_KEY: string = "ACCOUNT_BANNED_MESSAGE_SHOWN_SESSION_STORAGE_KEY"

  @ViewChild('banAlert', { static: false }) private banAlert;

  @ViewChild('cancelBookingConfirmation', { static: false }) private cancelBookingConfirmation;

  elementType: 'url' | 'canvas' | 'img' = 'url';

  value: string = '00000000';

  alertsOnPopUpPanel: Alert[] = [];

  bookings: Booking[];

  isCollapsed = true;

  displayedColumns = ['position', 'acc_name', 'deceased_name', 'bk_datetime', 'cancelBk'];

  //accountIdList = ['M000000','S000000-01','S000000-02'];

  accountIdselected;

  //loginAccount: Account;
  loginAccount = new Account("A00000000", "", "", "", "", "", "", new Date(), "", "", 1, "", "", 1, 1, 1, new Date(), "", new Date(), "");

  subAccounts: Account[] = [];

  accountIdDropDownOptions: string[] = ["id"];

  idDropDownDisabled: boolean = false;

  accountName: string = '';

  maxBookingInAdvanceDay: number = -1;

  cancelInAdvanceDay: number = -1;

  bookingView: BookingView[];


  constructor(
    private basicAuthenticationService: BasicAuthenticationService,
    private accountDataService: AccountDataService,
    private modalService: NgbModal,
    private obsDataService: ObsDataService,
    private systemDataService: SystemDataService,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef,
    private bookingDataService: BookingDataService
  ) { }

  async ngOnInit() {

    var bookingCancelAdvanceDayRes = await this.systemDataService.getSystemConfig(BOOKING_CANCEL_ADVANCE_DAY).toPromise<ApiResponse<SystemConfig>>();

    if (bookingCancelAdvanceDayRes.OK != null) {

      this.cancelInAdvanceDay = Number(bookingCancelAdvanceDayRes.OK.value);
    }
    else
      if (bookingCancelAdvanceDayRes.ERROR != null) {

        this.updateAlertArray(bookingCancelAdvanceDayRes.ERROR, false);

      }

    var maintenanceSystemConfigRes = await this.systemDataService.getSystemConfig(OBS_IS_UNDER_MAINTENANCE).toPromise<ApiResponse<SystemConfig>>();

    if (maintenanceSystemConfigRes.OK != null) {

      if (maintenanceSystemConfigRes.OK.value == IN_OPERATION_MODE) {

        this.initialise();

      }
      else
        if (maintenanceSystemConfigRes.OK.value == IN_MAINTENANCE_MODE) {

          this.basicAuthenticationService.clearSession();

          this.router.navigate(["maintenance"]);
        }
    }
    else
      if (maintenanceSystemConfigRes.ERROR != null) {
        this.updateAlertArray(maintenanceSystemConfigRes.ERROR, false);
      }


    var bookingMaxAdvanceDayRes = await this.systemDataService.getSystemConfig(BOOKING_MAX_ADVANCE_DAY).toPromise<ApiResponse<SystemConfig>>();

    if (bookingMaxAdvanceDayRes.OK != null) {

      this.maxBookingInAdvanceDay = Number(bookingMaxAdvanceDayRes.OK.value);
    }
    else
      if (bookingMaxAdvanceDayRes.ERROR != null) {

        this.updateAlertArray(bookingMaxAdvanceDayRes.ERROR, false);

      }


   

  }

  async initialise() {

    this.loginAccount = new Account("A00000000", "", "", "", "", "", "", new Date(), "", "", 1, "", "", 1, 1, 1, new Date(), "", new Date(), "");

    var accountRes = await this.accountDataService.getAccount(this.basicAuthenticationService.getAuthenticatedUser()).toPromise<ApiResponse<Account>>();

    if (accountRes.OK != null) {

      this.loginAccount = accountRes.OK;

      if (this.loginAccount.accountId === this.loginAccount.mainAccountId) {

        this.accountIdDropDownOptions = [];

        this.accountIdDropDownOptions.push("All");

        this.accountIdDropDownOptions.push(this.loginAccount.accountId);

        this.getSubAccount(this.loginAccount.accountId);

        this.accountIdselected = "All";
      }
      else {

        this.accountIdDropDownOptions = [];

        this.accountIdDropDownOptions.push(this.loginAccount.accountId);

        this.accountIdselected = this.loginAccount.accountId;

        this.idDropDownDisabled = true;

        this.accountName = this.loginAccount.fullName;

        this.refreshBookings([this.loginAccount.accountId]);

      }

      const fromDate: Date = new Date();

      const toDate: Date = new Date(this.loginAccount.banExpiryDate);

      if (!((<any>fromDate - <any>toDate) > 0)) {

        let bannedMessageShown = sessionStorage.getItem(this.ACCOUNT_BANNED_MESSAGE_SHOWN_SESSION_STORAGE_KEY);

        // to check if this message has been shown to the user
        if (bannedMessageShown == null) {

          this.showModal(this.banAlert);

          // record that the message has been shown to the user
          sessionStorage.setItem(this.ACCOUNT_BANNED_MESSAGE_SHOWN_SESSION_STORAGE_KEY, "1");
        }
      }

    }
    else
      if (accountRes.ERROR != null) {

        this.showAlertMessage(accountRes.ERROR, false);

      }


  }


  updateAccountName() {


    console.log("updateAccountName");

    let name: string;

    console.log(this.loginAccount.accountId + " - " + this.accountIdselected)

    if (this.loginAccount.accountId == this.accountIdselected) {
      name = this.loginAccount.fullName;
    }
    else {
      this.subAccounts.forEach(subAccount => {

        console.log(subAccount.accountId + " - " + this.accountIdselected)

        if (subAccount.accountId == this.accountIdselected) {

          name = subAccount.fullName;
        }

      });
    }

    if (this.accountIdselected != 'All') {
      this.refreshBookings([this.accountIdselected]);
    }
    else {
      let idList = Object.assign([], this.accountIdDropDownOptions);

      idList.shift();

      this.refreshBookings(idList);
    }

    this.accountName = name;
  }

  getSubAccount(mainAccountId: string) {

    this.accountDataService.getSubAccountByMainAccountId(mainAccountId).subscribe(

      response => {

        var firstKey = Object.keys(response)[0];

        if (firstKey.toUpperCase() == "OK") {
          this.subAccounts = response[firstKey];

          this.subAccounts.forEach(subAccount => {
            this.accountIdDropDownOptions.push(subAccount.accountId);
          });

          let idList = Object.assign([], this.accountIdDropDownOptions);

          idList.shift();

          this.refreshBookings(idList);
        }
        else
          if (firstKey.toUpperCase() == "ERROR") {

          }
      },
      error => {
      }

    );


  }



  showModal(content) {
    this.modalService.open(content).result.then(
      (closeResult) => {
        //modal close
        console.log("modal closed : ", closeResult);
      }, (dismissReason) => {
        //modal Dismiss
        if (dismissReason == ModalDismissReasons.ESC) {
          console.log("modal dismissed when used pressed ESC button");
        } else if (dismissReason == ModalDismissReasons.BACKDROP_CLICK) {
          console.log("modal dismissed when used pressed backdrop");
        } else {
          console.log(dismissReason);
        }
      })
  }

  bookingSelectedToBeCancelled: Booking;

  cancelBooking(booking: Booking) {

    this.bookingSelectedToBeCancelled = booking;

    this.showModal(this.cancelBookingConfirmation);


    //alert("123");

  }

  dismissAllModal() {
    this.modalService.dismissAll();
  }

  confirmCancelBooking() {

    this.modalService.dismissAll();

    this.bookingDataService
      .cancelBooking(this.bookingSelectedToBeCancelled)
      .subscribe(response => {

        var firstKey = Object.keys(response)[0];

        console.log(JSON.stringify(firstKey));

        if (firstKey.toUpperCase() == "OK") {

          for (var i = this.bookingView.length - 1; i > -1; i--) {
            if (this.bookingView[i].booking.bookingId == this.bookingSelectedToBeCancelled.bookingId) {
              this.bookingView.splice(i, 1);

              this.bookingView = [...this.bookingView];

              this.changeDetectorRefs.detectChanges();
            }
          }

        }
        else
          if (firstKey.toUpperCase() == "ERROR") {

          }

        //this.refreshBookings([this.loginAccount.accountId]);
      });
  }

  // updateBooking(id) {
  //   console.log(`delete ${id}`);

  //   this.bookingDataService
  //     .cancelBooking(this.loginAccount.accountId, id)
  //     .subscribe(response => {
  //       this.refreshBookings([this.loginAccount.accountId]);
  //     });
  // }

  refreshBookings(accountIdList: string[]) {

    this.bookings = [];

    this.bookingView = [];

    accountIdList.forEach(accountId => {

      let searchStartDate = new Date();

      var searchEndDate = new Date();
      if (this.maxBookingInAdvanceDay == -1) {
        this.maxBookingInAdvanceDay = 30;
      }
      searchEndDate.setDate(searchEndDate.getDate() + this.maxBookingInAdvanceDay);

      var lastCancellationDate = new Date();

      if (this.cancelInAdvanceDay == -1) {
        this.cancelInAdvanceDay = 7
      }

      lastCancellationDate.setDate(lastCancellationDate.getDate() + this.cancelInAdvanceDay);

      console.log("lastCancellationDate" + lastCancellationDate);

      this.bookingDataService.getBookingView(searchStartDate, searchEndDate, "", accountId, "pending").subscribe(response => {

        var firstKey = Object.keys(response)[0];

        if (firstKey.toUpperCase() == "OK") {

          this.bookingView = [...this.bookingView, ...response[firstKey]];

          console.log("Booking view length " + this.bookingView.length);

          this.bookingView.forEach(element => {

            console.log(element.booking.bookingId);
            console.log(element.account.fullName);
            console.log(element.deceasedNameString);
            console.log(element.booking.bookingDateTime);


            element.deceasedNameString = element.deceasedProfiles.map(function (elem) { return elem.name; }).join(", ");

            element.bookingStartDateLocaleString = new Date(element.booking.bookingTimeFrom).toLocaleDateString();

            if (element.queueTicket != null) {
              element.checkInTimeString = new Date(element.queueTicket.checkInTime).toLocaleTimeString();

              element.checkOutTimeSrring = new Date(element.queueTicket.checkOutTime).toLocaleTimeString();
            }


            //element.cancelIsAllowed = true;

            element.cancelIsAllowed = (new Date(element.booking.bookingTimeFrom) > new Date(lastCancellationDate)
                                       && element.booking.status.toLowerCase() == "pending"
                                       && element.booking.accountId == this.loginAccount.accountId
                                       );


          });

          this.changeDetectorRefs.detectChanges();
        }
        else
          if (firstKey.toUpperCase() == "ERROR") {
            this.showAlertMessage("Error occurred.", this.DASHBOARD_ALERT_TOP_POSITION);
          }
      },
        error => {
          console.log(error);
        });
    });
  }

  getAccountName(accountId: string) {

    console.log("getAccountName");

    let accountName: string = '';

    if (this.loginAccount.accountId == accountId) {
      accountName = this.loginAccount.fullName;
    }
    else {
      this.subAccounts.forEach(subAccount => {

        if (subAccount.accountId == accountId) {
          accountName = subAccount.fullName;
        }

      });
    }

    return accountName;
  }

  showAlertMessage(response, position) {
    let finalMessage: string;
    let alertType: string;

    if (response.result == "1") {
      finalMessage = response.message;
      alertType = "success";
    } else {
      if (response.message === DATA_OUTDATED) {
        finalMessage = DATA_OUTDATED_ALERT_MESSAGE;
        alertType = "danger";
      } else {
        finalMessage = response.message;
        alertType = "danger";
      }
    }

    let alertArr = Array.from([{ type: alertType, message: finalMessage }]);

    if (position === this.DASHBOARD_ALERT_TOP_POSITION) {
      this.alertsOnPopUpPanel = alertArr;
      setTimeout(() => {
        this.alertsOnPopUpPanel = []
      }, 5000);
    }
  }


  updateAlertArray(msg: string, success: boolean) {
    if (success) {
      this.alertsOnPopUpPanel = Array.from([{ type: "success", message: msg }]);
    } else {
      this.alertsOnPopUpPanel = Array.from([{ type: "danger", message: msg }]);
    }
    setTimeout(() => this.alertsOnPopUpPanel = [], 5000);
  }

}



export interface BookingView {

  account: Account;
  booking: Booking;
  queueTicket: QueueTicket;
  deceasedProfiles: DeceasedProfile[];

  deceasedNameString: string;
  bookingStartDateLocaleString: string;
  checkInTimeString: string;
  checkOutTimeSrring: string;

  cancelIsAllowed: boolean;

};
